module.exports = __webpack_public_path__ + "static/img/firstSwiper.e8900a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/firstSwiper.png
// module id = ZYN9
// module chunks = 1